import {
  ValueEntityResponse,
  ComponentElementsLayout,
  ComponentNavigationLinkButton,
  ComponentElementsColors,
  ComponentSectionsNlSub,
  PageEntityResponse,
  SubscribeDocument,
  Enum_Componentnavigationlinkbutton_Target,
} from "../graphql/generated/graphql";

export { lotsOfTags, tags } from "./tags";
export { pagePreviewItem } from "./pagePreviewItem";
export { image } from "./image";
export { menu } from "./menu";
export { tagCloud } from "./tagCloud";
import { colorsBgSlateTextDefault } from "./colors";
import { wrapperMarginLargeDefaultLayout } from "./wrapper";

export const navigationButtonExternalLinkSelf: ComponentNavigationLinkButton = {
  id: "button",
  externalUrl: "https://example.org",
  label: "You should click me!",
  target: Enum_Componentnavigationlinkbutton_Target.Self,
};

export const pagePath: PageEntityResponse = {
  data: {
    attributes: {
      path: "#",
    },
  },
};

export const newsletterWithTitleAndDesc: ComponentSectionsNlSub = {
  id: "1",
  title: "Subcribe to our newsletter",
  description:
    "We will show you a lot withou taking anything. It is a good deal!",
  privacy: pagePath,
};

export const apolloNewsletter = {
  mocks: [
    {
      request: {
        query: SubscribeDocument,
        variables: {
          email: "manuel@digitale-kumpel.ruhr",
        },
      },
      result: {
        data: {
          newsletter: {
            __typename: "NewsletterSubResponse",
            email: "manuel@digitale-kumpel.ruhr",
            description: "foo",
          },
        },
      },
    },
  ],
};

export const selectDefaultProps = {
  label: "Sort",
  options: [
    {
      id: "1",
      label: "Most Popular",
    },
    {
      id: "2",
      label: "Best Rating",
    },
    {
      id: "3",
      label: "Rating",
    },
    {
      id: "4",
      label: "Newest",
    },
    {
      id: "5",
      label: "Price from Low to High",
    },
    {
      id: "6",
      label: "Price from High to Low",
    },
  ],
};
